import request from './request'

/** POST /admin/auth/login */
export function login(data) {
  return request.post('/admin/auth/login', data)
}

/** GET /admin/auth/menus */
export function getAuthMenus() {
  return request.get('/admin/auth/menus')
}
